import React, { useEffect, useState } from "react";
import { Typography, Chip, Box, Button, Link } from "@mui/material";
import dayjs from 'dayjs';
import { observer } from "mobx-react";
import styles from '../my-data.module.scss';
import { ExportSquare } from "iconsax-react";
import { getPhoneNumberWihKey } from "../../utils/profile-utils";

const ViewInfo = observer(({ label, info, uiStore }) => {
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState({ lat: 10, lng: 10, zoom: 1 });
    const [availability, setAvailability] = useState(null);
    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

    useEffect(() => {
        async function fetchAddress() {

            if (label.infoType === "address" && info) {
                const countries = await uiStore.fetchInfoSuggestions('address');
                const sCountry = countries.find(i => i.name === info.country);
                setCountry(sCountry?.name + " - " + sCountry?.native);
                setState(info?.state);
                setCity(info?.city);
            }

            if (label.infoType === "location" && info) {
                const newLocation = JSON.parse(info.infoValue);
                setLocation(newLocation);
            }

            if (label.infoType === 'day-time' && info) {
                const ava = await uiStore.getAvailability(info?.infoValue);
                setAvailability(ava);
            }

        }

        fetchAddress()

    }, [label, info, uiStore])

    return (
        (!!info?.infoValue || !!info?.infoValues?.length) &&
        <>
            {label.infoType !== 'address' ?
                <Box key={label._id + 'view'} className={styles.mydataInfoBlock}>
                    <Typography fontSize='12px'>{label.name}</Typography>

                    {label.multipleValues ?
                        info?.infoValues?.map(infoValue => (
                            <Chip
                                key={infoValue}
                                color='lightblue'
                                sx={{ mr: 1, mt: 1 }}
                                label={
                                    <Typography fontSize='14px' fontWeight={600}>
                                        {infoValue}
                                    </Typography>
                                }
                            />
                        ))
                        :
                        <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word', whiteSpace: 'pre-line' }}>
                            {label.infoType === 'date' &&
                                <>
                                    {label.name === 'Birthday' ?
                                        dayjs(info?.infoValue).format('dddd, MMM D')
                                        :
                                        dayjs(info?.infoValue).format('ddd D, MMM YYYY')
                                    }
                                </>
                            }

                            {label.infoType === 'number' &&
                                <>
                                    {getPhoneNumberWihKey(info)}
                                </>
                            }

                            {label.infoType === 'location' &&
                                <Button
                                    endIcon={
                                        <ExportSquare
                                            size="18"
                                            variant="Outline"
                                        />}
                                    href={`https://www.google.com/maps/search/?api=1&query=${location?.lat},${location?.lng}`}
                                    target="_blank"
                                    rel='noopener noreferrer'
                                    color="greyPrimary"
                                >

                                    View Location
                                </Button>
                            }

                            {label.infoType === 'day-time' && availability &&
                                <Box>
                                    {availability.status === 'open' &&
                                        <Box>
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500}>{day}</Typography>
                                                    Available All day | Open 24 hrs
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                    {availability.status === 'closed' &&
                                        <Box >
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500}>{day}</Typography>
                                                    Not available | Closed
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                    {availability.status === 'custom' &&
                                        <Box>
                                            {days.map(day =>
                                                <Box key={day} className={styles.avaBox}>
                                                    <Typography fontWeight={500} fontSize={12}>{day}</Typography>
                                                    {dayjs(availability[day]['from']).format('hh:mm A')} - {dayjs(availability[day]['to']).format('hh:mm A')}
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                </Box>
                            }

                            {label.infoType === 'URL' &&
                                <Link rel='noopener noreferrer' target="_blank" href={info.infoValue}>{info.infoValue}</Link>
                            }

                            {label.infoType !== 'number' && label.infoType !== 'date' && label.infoType !== 'location' && label.infoType !== 'day-time' && label.infoType !== 'URL' &&
                                info?.infoValue
                            }
                        </Typography>
                    }
                </Box>
                :
                <>
                    {country &&
                        <Box className={styles.mydataInfoBlock}>
                            <Typography fontSize='12px'>Country</Typography>
                            <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word' }}>
                                {country}
                            </Typography>
                        </Box>
                    }

                    {state &&
                        <Box className={styles.mydataInfoBlock}>
                            <Typography fontSize='12px'>State</Typography>
                            <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word' }}>
                                {state}
                            </Typography>
                        </Box>
                    }

                    {city &&
                        <Box className={styles.mydataInfoBlock}>
                            <Typography fontSize='12px'>City</Typography>
                            <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word' }}>
                                {city}
                            </Typography>
                        </Box>
                    }
                </>
            }
        </>
    );
});

export default ViewInfo;